/*
 * @Author: song 
 * @Date: 2018-07-17 14:19:11 
 * @Last Modified by: song
 * @Last Modified time: 2018-07-17 15:46:35
 */

import prodb from './prodb';
import publish from "./publish";


export default {
  prodb,
  publish
};



// WEBPACK FOOTER //
// ./src/api/index.js